import { Unit } from 'domain/unit';
import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';

interface UnitPickerProps {
    selectedUnit: Unit;
    options: Unit[];
    onUnitSelected(u: Unit): void;
    className?: string;
}

const UnitPicker: React.FC<UnitPickerProps> = React.memo(props => {
    return <DropdownButton id="uom-picker" className={props.className} title={props.selectedUnit?.name} variant={null}>
        {props.options.map(u =>
            <Dropdown.Item onClick={() => props.onUnitSelected(u)} key={u.id}>
                {u.name}
            </Dropdown.Item>
        )}
    </DropdownButton>
})



export default UnitPicker;





